import { ArrowRight, FolderClosed } from "lucide-react";
import React, { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { Flip, ToastContainer, toast } from "react-toastify";
import FullScreenLoader from "../../FullScreenLoader";
import ButtonLoading from "../../ButtonLoading";
// import Poster from "../../../assets/images/poster.png";
// import { CloseSVG } from "../../CloseSVG";
// import axios from "axios";
// import "firebase/firestore";
// import firebase from "firebase/compat/app";
// import "firebase/compat/firestore";
// import "firebase/compat/auth";

const MatchEntryModal = ({ visible, onClose, data, isWithdraw }) => {
  const { authenticated, setAuthenticated } = useAuth();
  const [modalData, setmodalData] = useState({});
  const axiosPrivate = useAxiosPrivate();
  const [userBalance, setUserBalance] = useState(
    authenticated?.user?.balance || 0
  ); // Local state for balance
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authenticated?.user?.balance) {
      setUserBalance(authenticated.user.balance); // Initialize balance state
    }
  }, [authenticated]);

  useEffect(() => {
    console.log(isWithdraw);
  }, []);

  const handleOnClose = (e) => {
    if (e.target.id === "ModalContainer") {
      onClose();
    }
  };
  if (!visible) {
    return null;
  }
  const handleSubmit = async () => {
    console.log("first this is submit from modal");
    setLoading(true);
    console.log(authenticated?.user);
    userBalance >= data?.fees
      ? await axiosPrivate
          .post(
            `/listings/SingleMatchCard/${data?._id}`,
            {},
            { withCredentials: true }
          )
          .then((res) => {
            console.log(res?.data);
            const updatedBalance = res?.data?.newBalance;
            if (updatedBalance !== undefined) {
              setUserBalance(updatedBalance); // Update local state
              setAuthenticated((prev) => ({
                ...prev,
                user: { ...prev.user, balance: updatedBalance }, // Update global state
              }));
            }
            toast.success(
              `You have joined the match - ${data?.matchId} successfully! 👌`,
              {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
              }
            );
            setLoading(false);
            navigate("/dashboard/myMatches");
          })
          .catch((err) => console.log(err))
      : toast.error(
          `You dont have enough balance to participate in this match! Balance required ${data?.fees}, Your Balance ${authenticated?.user?.balance}. Please topup now! `,
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Flip,
          }
        );
    setLoading(false);
  };

  const handleWithdrawSubmit = async () => {
    setLoading(true);
    await axiosPrivate
      .post(
        `/listings/SingleMatchCardWithdraw/${data?._id}`,
        {},
        { withCredentials: true }
      )
      .then((res) => {
        console.log(res?.data);
        const updatedBalance = res?.data?.newBalance;
        if (updatedBalance !== undefined) {
          setUserBalance(updatedBalance); // Update local state
          setAuthenticated((prev) => ({
            ...prev,
            user: { ...prev.user, balance: updatedBalance }, // Update global state
          }));
        }
        setLoading(false);
        navigate("/dashboard");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <>
      <div
        id="ModalContainer"
        onClick={handleOnClose}
        className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur flex justify-center items-center"
      >
        <ToastContainer />
        <div className="bg-black m-2 shadow-lg rounded-xl">
          <div className="flex flex-end justify-end">
            <button onClick={onClose} className="mt-1 me-1 mb-1">
              {/* <CloseSVG /> */}
            </button>
          </div>
          {/* {modalData} */}
          <div className="px-5 pb-5 ">
            <div className="p-4">
              <h3 className="text-xl">Important Notice :</h3>
              {isWithdraw !== true ? (
                <>
                  <h3 className="text-lg">
                    Are You Sure You want to enter this Room?
                  </h3>
                  <p className="text-sm">
                    Your Balance - ({data?.fees} PKR) will be deducted as soon
                    as you click <strong>Yes.</strong>
                  </p>
                </>
              ) : (
                <>
                  <h3 className="text-lg">
                    Are You Sure You want to Withdraw from this Room?{" "}
                  </h3>
                  <p className="text-sm">
                    Your Balance - ({data?.fees} PKR) will be restored as soon
                    as you click <strong>Yes.</strong>.
                  </p>
                  <p className="text-sm">
                    {" "}
                    You will no longer be participant in this match.
                  </p>
                </>
              )}
            </div>
            <div className="flex justify-between items-center">
              <button
                onClick={() => {
                  isWithdraw !== true ? handleSubmit() : handleWithdrawSubmit();
                }}
                disabled={loading}
                className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-green-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-green-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
              >
                {loading ? (
                  <>
                    <ButtonLoading />
                  </>
                ) : (
                  <>
                    <p> Yes</p> <ArrowRight />
                  </>
                )}
              </button>
              <button
                onClick={() => {
                  onClose();
                }}
                disabled={loading}
                className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-red-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
              >
                <p> No</p>X
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MatchEntryModal;
